import React, { useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import GlobalContext from '../../context/store';
import useCompanyEvents from '../../hooks/useCompanyEvents';
import { eventImage, eventPlace } from '../../helpers/eventDisplay';

export default function Events({ companyId: companyIdProp }) {
  const { company } = useContext(GlobalContext);
  const companyId = companyIdProp || company?._id;
  const { events, loading, error } = useCompanyEvents(companyId);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="ticket-page ticket-events" aria-labelledby="events-heading">
      <div className="container">
        <div className="ticket-page__intro">
          <p className="ticket-eyebrow">Dollhouse Mermaid</p>
          <h1 id="events-heading" className="ticket-page__title">Events</h1>
        </div>

        {loading && <div className="ticket-state"><p>Loading events...</p></div>}
        {error && <div className="ticket-state ticket-state--error" role="alert"><p>Events are unavailable right now. Please try again later.</p></div>}
        {!loading && !error && events.length === 0 && (
          <div className="ticket-state">
            <p>Nothing on the calendar yet. Check back soon, or book a private glam in the meantime.</p>
          </div>
        )}

        <div className="ticket-event-grid">
          {events.map((event) => {
            const image = eventImage(event);
            const place = eventPlace(event);
            const when = [event.start_date_display, event.start_time_display].filter(Boolean).join(' · ');

            return (
              <article className={`ticket-event-card${image ? '' : ' ticket-event-card--no-image'}`} key={event._id || event.slug}>
                <Link className="ticket-event-card__link" to={`/events/event/${event.slug}`}>
                  <div className="ticket-event-card__image">
                    {image ? <img src={image} alt="" /> : <span className="ticket-event-card__monogram" aria-hidden="true">DM</span>}
                  </div>
                  <div className="ticket-event-card__body">
                    {when && <p className="ticket-meta ticket-event-card__meta">{when}</p>}
                    <h2 className="ticket-event-card__title">{event.name}</h2>
                    {place.line && <p className="ticket-event-card__venue">{place.line}</p>}
                    <span className="ticket-event-card__cta">Get tickets</span>
                  </div>
                </Link>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
